import React from 'react'

import TadAiAudioPlayer from './TadAiAudioPlayer'

import { useAuthStatusChange } from '@/pages/tad.ai/_hooks/useAuthStatusChange'
import { useAuthStatusEvents } from '@/pages/tad.ai/_hooks/useAuthStatusEvents'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
export interface SiteGlobalComponentProps {
  children?: React.ReactNode
}

const SiteGlobalComponent: React.FC<SiteGlobalComponentProps> = () => {
  const globalAudioPlayer = useGlobalAudioPlayer()

  useAuthStatusEvents()
  useAuthStatusChange([
    {
      onLogout: () => globalAudioPlayer.unLoad(),
      onSwitchUser: () => globalAudioPlayer.unLoad(),
    },
  ])

  if (!globalAudioPlayer.meta) {
    return null
  }

  return <TadAiAudioPlayer />
}

export default SiteGlobalComponent
